import styled from "@emotion/styled";
import { Grid, ThemeProps } from "common/components/ui";

export const CancelTransferActionItems = styled(Grid)<ThemeProps>(
  ({ theme }) => `
  margin-top: ${theme.spacing.S7};
  margin-bottom: 0;
`
);
